import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { MultiselectorGuiaList } from "./components/list";
import { ConceptoFacturaList } from "./conceptosfacturas";

interface Props {
    factura: models.FacturaDto;
}

class FacturaGuiaNoRX extends React.PureComponent<Props> {
    factura = (x: Props) => x.factura;
    render() {
        const factura = this.factura(this.props);
        return (
            <div>
                <kea.Tab items={[
                    {
                        title: "Factura", body: <InformacionFactura value={factura} />
                    }
                ]} />
            </div>
        )
    }
}

export const FacturaGuia = componentToRx(FacturaGuiaNoRX);

export interface PropsInformacion {
    value: models.FacturaDto;
}

class InformacionFacturaNoRx extends React.PureComponent<PropsInformacion> {
    value = (props: PropsInformacion) => props.value;
    esFacturadaOnline = (props: PropsInformacion) => props.value.Origen == models.OrigenFactura.FacturacionOnline;

    render() {
        const { value } = this.props;
        const esfacturadaOnline = this.esFacturadaOnline(this.props);
        return (
            <div>
                <kea.Title titulo={"Factura"} />
                {kea.autogrid(6, [
                    kea.autogrid(4, [
                        <kea.Text value={value.SerieFolio} label="Factura:" readonly={true} />,
                        <kea.Text value={models.OrigenFactura[this.props.value.Origen]} label="Origen de la factura" readonly={true} />,
                        <kea.DateTime value={value.FechaCreacion} label="Fecha de creación" time readonly />,
                        <kea.DateTime value={value.FechaFactura} label="Fecha de factura" time readonly={true} />,
                        <kea.DateTime value={value.FechaPolizaContable} label="Fecha de póliza contable" time readonly={true} />,
                        <selectores.ClaveFormaPagoSat value={value.IdFormaPagoSAT} label="Forma de pago" readonly={true} />,
                        <selectores.ClaveMetodoPagoSat value={value.IdMetodoPagoSAT} label="Método de pago" readonly={true} />,
                        <kea.Text value={value.IataSucursal} label="Sucursal:" readonly={true} />,
                        <selectores.TipoCaptura value={value.TipoCaptura} label="Tipo de captura:" readonly={true} />,
                        <selectores.TipoFactura value={value.Tipo} label="Tipo:" readonly={true} />,
                        <kea.Text value={value.NoCuentaOrdenante} label="Número cuenta ordenante:" readonly={true} />,
                        <kea.Text value={value.NoCuentaBeneficiaria} label="Número cuenta beneficiaria:" readonly={true} />,
                        <selectores.ClaveMonedaSat value={value.ClaveSatMoneda} label="Moneda:" readonly={true} />,
                        <kea.Number value={value.TipoCambio} label="Tipo de cambio:" readonly={true} />,
                        <selectores.ClaveUsoCFDISat value={value.ClaveSatUsoReceptor} label="Uso de CFDI:" readonly={true} />,
                        <selectores.ClaveRegimenFiscalSat value={value.ClaveSatRegimenFiscalEmisor} label="Régimen fiscal del emisor:" readonly={true} />,
                        <kea.Text value={value.Observaciones} label="Observaciones:" readonly={true} />
                    ]),
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            <span>
                                <i className="fa fa-" />
                                Receptor
                            </span>
                        </div>

                        <div className="panel-body">
                            {kea.autogrid(6, [
                                <kea.Text value={ value.NombreCliente  } label="Cliente:" readonly={true} />
                            ])}
                            {kea.autogrid(6, [
                                <selectores.TipoPersona value={ value.ReceptorFactura.TipoPersona} label="Tipo de persona:" readonly={true} />,
                                <kea.Text value={value.ReceptorFactura.Rfc } label="RFC:" readonly={true} />,
                                <kea.Text value={value.ReceptorFactura.NumeroRegistroIdentidadFiscal} label="No. registro identidad fiscal:" readonly={true} />
                            ])}
                        </div>

                    </div>
                ])}
                <ConceptoFacturaList value={value.Conceptos} />
            </div>);
    }
}

export const InformacionFactura = componentToRx(InformacionFacturaNoRx);





// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturaciononline/edit/factura.tsx